import { PostUserPersistedFlightRequest } from '../services/PostUserPersistedFlightRequest';
import { postUserPersistedFlight } from '../services/postUserPersistedFlgiht';
import persistFlight from 'owa-premium-flight/lib/mutators/persistFlight';
import store from '../store/premiumFlightStore';

export async function persistUserFlight(flightName: string) {
    if (flightName && store.flightNames.indexOf(flightName.toLowerCase()) == -1) {
        persistFlight(flightName);
        let request: PostUserPersistedFlightRequest = { flightName: flightName };
        await postUserPersistedFlight(request);
    }
}
